import axios from "axios";
 
const getSafeToken = () => {
  const raw = window.localStorage.getItem("token");
 
  if (!raw) return "";
 
  // case 1: already clean JWT
  if (raw.startsWith("ey")) return raw;
 
  // case 2: JSON string => "eyJhbGciOi..."
  if (raw.startsWith('"')) {
    try {
      return JSON.parse(raw);
    } catch {
      return raw.replace(/"/g, "");
    }
  }
  
  // case 3: object => { token: "ey..." }
  try {
    const parsed = JSON.parse(raw);
    return parsed?.token || "";
  } catch {
    return "";
  }
};
 
 
// Base URL for .concat usage
const BaseUrl = "https://admin.dollarempirellc.com";
// const BaseUrl = "https://doller-empire.onrender.com"; 
const token = getSafeToken();

// User language
const userLang = window.localStorage.getItem("user_lang") || "en";
 
// Axios instances
export const PostUrl = axios.create({
  baseURL: `${BaseUrl}/api`,
  method: "post",
  headers: {
    "Accept-Language": userLang,
    Authorization: token ? `Bearer ${token}` : "",
  },
});
 
export const GetUrl = axios.create({
  baseURL: `${BaseUrl}/api`,
  method: "get",
  headers: {
    "Accept-Language": userLang,
    Authorization: token ? `Bearer ${token}` : "",
  },
});
 
if (token) {
  window.localStorage.setItem("token", token);
}
 
export default BaseUrl;
 


